import React from 'react'
import AppDropDown from '../component/dropDown';
import { Box, Button, Container, Grid, TextField, Typography } from '@material-ui/core'
import "./search_pdf_admission.css";
import axios from 'axios';
import { useState } from 'react';
import { baseURL } from '../utils/axois_instance';
import { useHistory } from 'react-router';


export const Search_PDF_Admission = () => {
  const [searched_data, setSearched_data] = useState([])
  const [user_input, setUser_input] = useState({})





  const search_handle = () => {

    if (!user_input.email || !user_input.cnic) {
      alert('All fields are required!')
    }
    else {
      axios.post(`${baseURL}/search-admission-pdf`, user_input).then((res) => {
        const data = res.data

        console.log({ data });

        setSearched_data(data.data)
      })
    }
  }

  const history = useHistory()


  const navigate_to_pdf_page = (id) => {

    history.push(`/generate-pdf/${id}`);

  }



  return (
    <Container>

      <Box sx={{ gap: '30px' }} >
        <Typography variant='h4' fontWeight="bold">
          Search PDF
        </Typography>
        <Typography variant='body2'>
          Enter the following details to search the PDF
        </Typography>
      </Box>

      <hr />

      <Grid container spacing={3} alignItems='flex-end'>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>

          <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            <Typography>
              CNIC # <span style={{ color: 'red' }}>*</span>
            </Typography>

            <TextField onChange={(e) => setUser_input({ ...user_input, cnic: e.target.value })} sx={{ flex: 1 }} variant='outlined' placeholder='Enter CNIC #' />
          </Box>

        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            <Typography>
              Email <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField onChange={(e) => setUser_input({ ...user_input, email: e.target.value })} sx={{ flex: 1 }} variant='outlined' placeholder='Enter email' />
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            <Typography>
            </Typography>
            <button onClick={search_handle} style={{ backgroundColor: '#28a745', outline: 'none', borderStyle: 'none', color: 'white', padding: '15px 0', borderRadius: '10px', pointerEvents: 'all', cursor: 'pointer' }}>
              Search
            </button>
          </Box>
        </Grid>
      </Grid>


      <Box>
        <table id="data-table" className="my-4">
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Father Name</th>
            <th>CNIC</th>
            <th>Course</th>
            <th>Institute</th>
            <th>Batch</th>
            <th>Timing</th>
            <th>Status</th>
            <th>Action</th>
          </tr>

          {searched_data &&
            searched_data.map((data, ind) => {
              return (
                <tr key={ind}>
                  <td>{data.generatedId}</td>
                  <td>{data.fullName}</td>
                  <td>{data.fatherName}</td>
                  <td>{data.cnic}</td>
                  <td>{data.course}</td>
                  <td>{data.institute}</td>
                  <td>{data.batch}</td>
                  <td>{data.time}</td>
                  <td>{data.fees}</td>
                  <td
                    onClick={() => navigate_to_pdf_page(data.generatedId)}
                    data-toggle="modal"
                    data-target="#staticBackdrop"
                    style={{ cursor: "pointer", color: "green" }}
                  >
                    View
                  </td>
                </tr>
              );
            })}
        </table>
      </Box>





    </Container>
  )
}

